/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { APIEmployeeSearchResult } from './APIEmployeeSearchResult';
import {
    APIEmployeeSearchResultFromJSON,
    APIEmployeeSearchResultFromJSONTyped,
    APIEmployeeSearchResultToJSON,
} from './APIEmployeeSearchResult';
import type { APIPagination } from './APIPagination';
import {
    APIPaginationFromJSON,
    APIPaginationFromJSONTyped,
    APIPaginationToJSON,
} from './APIPagination';

/**
 * 
 * @export
 * @interface APIEmployeeSearchResponse
 */
export interface APIEmployeeSearchResponse {
    /**
     * 
     * @type {number}
     * @memberof APIEmployeeSearchResponse
     */
    total: number;
    /**
     * 
     * @type {number}
     * @memberof APIEmployeeSearchResponse
     */
    maxScore: number | null;
    /**
     * 
     * @type {Array<APIEmployeeSearchResult>}
     * @memberof APIEmployeeSearchResponse
     */
    results: Array<APIEmployeeSearchResult>;
    /**
     * 
     * @type {APIPagination}
     * @memberof APIEmployeeSearchResponse
     */
    page: APIPagination;
}

/**
 * Check if a given object implements the APIEmployeeSearchResponse interface.
 */
export function instanceOfAPIEmployeeSearchResponse(value: object): value is APIEmployeeSearchResponse {
    if (!('total' in value) || value['total'] === undefined) return false;
    if (!('maxScore' in value) || value['maxScore'] === undefined) return false;
    if (!('results' in value) || value['results'] === undefined) return false;
    if (!('page' in value) || value['page'] === undefined) return false;
    return true;
}

export function APIEmployeeSearchResponseFromJSON(json: any): APIEmployeeSearchResponse {
    return APIEmployeeSearchResponseFromJSONTyped(json, false);
}

export function APIEmployeeSearchResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIEmployeeSearchResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'total': json['total'],
        'maxScore': json['max_score'],
        'results': ((json['results'] as Array<any>).map(APIEmployeeSearchResultFromJSON)),
        'page': APIPaginationFromJSON(json['page']),
    };
}

export function APIEmployeeSearchResponseToJSON(value?: APIEmployeeSearchResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'total': value['total'],
        'max_score': value['maxScore'],
        'results': ((value['results'] as Array<any>).map(APIEmployeeSearchResultToJSON)),
        'page': APIPaginationToJSON(value['page']),
    };
}

